import {
	alpha,
	Button as MUIButton,
	ButtonProps,
	styled,
	useTheme,
} from "@mui/material";
import { forwardRef } from "react";

const CustomButton = styled(MUIButton)(({ theme }) => ({
	"&.MuiButton-containedSecondary": {
		color: theme.palette.secondary.dark,
		backgroundColor: theme.palette.grey[100],
		"&:hover": {
			backgroundColor: theme.palette.grey[200],
		},
	},
	"&.MuiButton-containedPrimary": {
		color: theme.palette.background.paper,
		backgroundColor: theme.palette.primary.main,
		transitionDuration: "0.5s",
		"&:hover": {
			backgroundColor: alpha(theme.palette.primary.main, 0.6),
		},
	},
	"&.MuiButton-textPrimary": {
		color: theme.palette.primary.main,
		"&:hover": {
			backgroundColor: theme.palette.secondary.light,
			color: theme.palette.background.paper,
		},
	},
	"&.MuiButton-textSecondary": {
		color: theme.palette.grey[700],
		"&:hover": {
			backgroundColor: theme.palette.grey[200],
			color: theme.palette.secondary.dark,
		},
	},
	"&.Mui-disabled": {
		color: theme.palette.grey[500],
	},
}));

export interface StyledButtonProps extends ButtonProps {
	component?: React.ElementType;
	to?: string;
	primaryBackground?: boolean;
}

export const StyledButton = forwardRef(function Button(
	{ primaryBackground, ...props }: StyledButtonProps,
	ref,
): JSX.Element {
	const theme = useTheme();

	return (
		<CustomButton
			ref={ref as ButtonProps["ref"]}
			{...props}
			sx={
				primaryBackground
					? {
							":hover": {
								backgroundColor: alpha(theme.palette.background.default, 0.3),
							},
							...props.sx,
					  }
					: props.sx
			}
		/>
	);
});
